// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content-target {
  margin: 2rem 0;
}

.list-target {
  display: flex;
  flex-flow: row wrap;
  gap: 0.5rem;
  margin: 2rem 0;
  align-items: center;
}

.btn-train {
  cursor: pointer;
  width: 4rem;
}

.train-label {
  margin: 1rem 0;
  font-size: 1.5rem;
  text-transform: uppercase;
  align-self: flex-end;
}

@media screen and (max-width: 768px) {
  .train-label {
    font-size: 1rem;
  }

  .list-target {
    margin: 0.5rem 0;
    gap: 0.25rem;
  }

  .btn-train {
    cursor: pointer;
    width: 3.25rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/trains.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;AACF","sourcesContent":[".content-target {\n  margin: 2rem 0;\n}\n\n.list-target {\n  display: flex;\n  flex-flow: row wrap;\n  gap: 0.5rem;\n  margin: 2rem 0;\n  align-items: center;\n}\n\n.btn-train {\n  cursor: pointer;\n  width: 4rem;\n}\n\n.train-label {\n  margin: 1rem 0;\n  font-size: 1.5rem;\n  text-transform: uppercase;\n  align-self: flex-end;\n}\n\n@media screen and (max-width: 768px) {\n  .train-label {\n    font-size: 1rem;\n  }\n\n  .list-target {\n    margin: 0.5rem 0;\n    gap: 0.25rem;\n  }\n\n  .btn-train {\n    cursor: pointer;\n    width: 3.25rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
